import React, { useEffect, useState } from 'react';
import "../../assets/styles/Profile.css";
import Popup from "reactjs-popup";
import { motion } from "framer-motion";
import Header from "../../components/Header.js";
import InfoUser from "../../components/Profile/InfoUser.js";
import imgBtnUser from "../../imgs/bt-change-name.png";
import imgBtnUserHover from "../../imgs/bt-change-name-hover.png";
import imgBtnPhone from "../../imgs/bt-change-phone.png";
import imgBtnPhoneHover from "../../imgs/bt-change-phone-hover.png";
import imgBtnMail from "../../imgs/bt-change-mail.png";
import imgBtnMailHover from "../../imgs/bt-change-mail-hover.png";
import imgBtnBank from "../../imgs/bt-change-bank.png";
import imgBtnBankHover from "../../imgs/bt-change-bank-hover.png";
import imgBtnBirthday from "../../imgs/bt-change-birthday.png";
import imgBtnUsdt from "../../imgs/bt-change-usdt.png";
import imgBtnPassLogin from "../../imgs/bt-pass-login.png";
import imgBtnPassWithdraw from "../../imgs/bt-pass-withdraw.png";
import iconArrow from "../../icons/icon-arrow.png";
import iconLinkskh from "../../icons/icon-link-cskh.png";
import iconClose from "../../icons/icon-close.png";
import { useLocation, useNavigate } from "react-router-dom";
import Collapsible from "react-collapsible";
import Swal from "sweetalert2";
import { apiGetRequestHistory } from "../../services/api.service.js";
import HtmlNote from "../../components/Profile/HtmlNote.js";

function Profile() {
  const location = useLocation();
  const { userName, data, webSetting } = location.state || {};
  const navigate = useNavigate();
  const [requestCode, setRequestCode] = useState("");
  const [requestHistory, setRequestHistory] = useState(null);
  const [requestHistoryError, setRequestHistoryError] = useState("");
  const [openRequestHistoryResult, setOpenRequestHistoryResult] = useState(false);
  const [showRequestHistoryHelp, setShowRequestHistoryHelp] = useState(false);
  const [isRequestHistoryCollapsed, setIsRequestHistoryCollapsed] = useState(false);
  const [recentRequests, setRecentRequests] = useState((data?.recent_requests || []).slice(0, 2));
  // danh sách mục thông tin tài khoản không được phép thay đổi (BE trả về khi check tài khoản)
  const disabledUpdateTypes = data?.disabled_update_types || [];
  // class nút: mục bị giới hạn thì làm mờ, không cho bấm
  const actionClass = (updateType, className = "action-btn") => {
    return disabledUpdateTypes.includes(updateType) ? `${className} action-disabled` : className;
  };

  useEffect(() => {
    setRecentRequests((data?.recent_requests || []).slice(0, 2));
  }, [data]);

  const requestStatusText = {
    no_process: "Đang chờ xử lý",
    approved: "Đã xử lý thành công",
    removed: "Đã từ chối",
  };

  const requestTypeText = {
    full_name: "Thay đổi họ và tên",
    phone_number: "Thay đổi số điện thoại",
    email: "Thay đổi email",
    bank: "Thay đổi tài khoản ngân hàng",
    birthday: "Thay đổi ngày sinh",
    forget_password: "Cấp lại mật khẩu đăng nhập",
    forget_password_withdraw: "Cấp lại mật khẩu rút tiền",
  };

  const getVerificationStatusText = (status, sendType) => {
    if (status === "success") return "Đã nhận xác thực hợp lệ";
    if (status === "invalid") return sendType === "email"
      ? "Đã nhận xác thực nhưng sai địa chỉ email"
      : "Đã nhận xác thực nhưng sai số điện thoại";
    return sendType === "email" ? "Chưa nhận được email xác thực" : "Chưa nhận được SMS xác thực";
  };

  const maskRequestCode = (code = "") => {
    const value = String(code || "");
    return value.startsWith("xxxxxx") ? value : `xxxxxx${value.slice(-2)}`;
  };

  const shouldNavigate = !userName || userName === "undefined";
  useEffect(() => {
    if (shouldNavigate) {
      navigate('/');
    }
  }, [navigate, shouldNavigate]);

  const checkRequestHistory = async () => {
    const code = requestCode.trim();
    setRequestHistoryError("");
    if (!/^\d{8}$/.test(code)) {
      setRequestHistoryError("Vui lòng nhập đúng mã yêu cầu gồm 8 số.");
      return;
    }

    const result = await apiGetRequestHistory(userName, code);
    if (result?.code === 200 && result?.data?.request) {
      setRequestHistory(result.data.request);
      setOpenRequestHistoryResult(true);
    } else {
      setRequestHistoryError(result?.message || "Không tìm thấy yêu cầu.");
    }
  };

  if (!shouldNavigate) {
    const changeInfo = async (typeModal) => {
      if (!userName) {
        return Swal.fire({ icon: "error", text: "Vui lòng nhập tên tài khoản." });
      }
      navigate("/change-info", { state: { userName, data, webSetting, typeModal } });
    };

    return (
      <div className="container">
        <motion.div
          className="app"
          initial={{ x: "100vw", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: "-100vw", opacity: 0 }}
          transition={{ type: "spring", stiffness: 1000, damping: 200, duration: 10 }}
        >
          <Header isPageSearch={false} />
          {/* <div className="info-current">
            <Collapsible open={true} trigger={["THÔNG TIN CÁ NHÂN", <img src={iconArrow} key="icon-arrow" alt="icon-arrow" />]}>
              <InfoUser />
            </Collapsible>
          </div> */}
          <div className="content">
            <div className="profile">
              <div className="profile-request-history">
                <div className="request-history-header">
                  <span className="profile-titlte">LỊCH SỬ YÊU CẦU</span>
                  <div className="request-history-header-actions">
                    <button
                      type="button"
                      className="request-history-toggle"
                      onClick={() => setIsRequestHistoryCollapsed((value) => !value)}
                    >
                      {isRequestHistoryCollapsed ? "Hiện lịch sử" : "Ẩn lịch sử"}
                    </button>
                    <span className="request-history-help-wrap">
                      <button
                        type="button"
                        className="request-history-help-icon"
                        onMouseEnter={() => setShowRequestHistoryHelp(true)}
                        onMouseLeave={() => setShowRequestHistoryHelp(false)}
                        onClick={() => setShowRequestHistoryHelp((value) => !value)}
                      >
                        !
                      </button>
                      {showRequestHistoryHelp && (
                        <div className="request-history-help-content">
                          Danh sách chỉ hiển thị tối đa 2 yêu cầu gần nhất trong 48 giờ. Nhập mã yêu cầu 8 số để xem chi tiết kết quả xử lý.
                        </div>
                      )}
                    </span>
                  </div>
                </div>

                {!isRequestHistoryCollapsed && recentRequests.length > 0 && (
                  <div className="recent-requests">
                    {recentRequests.map((request, index) => (
                      <div className={`recent-request-item status-${request.status}`} key={`${request._request_code || request.request_code}-${index}`}>
                        <div className="recent-request-main">
                          <strong>{requestTypeText[request.update_type] || request.update_type}</strong>
                          <span className="recent-request-code">Mã yêu cầu: {maskRequestCode(request.request_code)}</span>
                        </div>
                        <div className="recent-request-meta">
                          <span className={`recent-request-status status-${request.status}`}>
                            {requestStatusText[request.status] || request.status}
                          </span>
                          {request.status === "no_process" && ["email", "phone_number"].includes(request.send_type) && (
                            <span className={`verification-status verification-${request.verification_status || "not_received"}`}>
                              {getVerificationStatusText(request.verification_status || "not_received", request.send_type)}
                            </span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                <div className="request-history-form">
                  <input
                    type="text"
                    inputMode="numeric"
                    maxLength="8"
                    value={requestCode}
                    onChange={(event) => {
                      setRequestCode(event.target.value.replace(/\D/g, ""));
                      setRequestHistoryError("");
                    }}
                    onKeyDown={(event) => event.key === "Enter" && checkRequestHistory()}
                    placeholder="Nhập mã yêu cầu 8 số"
                  />
                  <button type="button" onClick={checkRequestHistory}>Kiểm tra</button>
                </div>

                {requestHistoryError && (
                  <p className="request-history-error">{requestHistoryError}</p>
                )}
              </div>

              <span className="profile-titlte title-btn-change">THAY ĐỔI THÔNG TIN</span>
              <div className="action">
                <div className={actionClass("full_name")} onClick={() => !disabledUpdateTypes.includes("full_name") && changeInfo("full_name")}>
                  <img className="img-default" src={imgBtnUser} alt="icon-user" />
                  <img className="img-hover" src={imgBtnUserHover} alt="icon-user" />
                </div>
                <div className={actionClass("phone_number")} onClick={() => !disabledUpdateTypes.includes("phone_number") && changeInfo("phone_number")}>
                  <img className="img-default" src={imgBtnPhone} alt="icon-phone" />
                  <img className="img-hover" src={imgBtnPhoneHover} alt="icon-user" />
                </div>
              </div>
              <div className="action">
                <div className={actionClass("email")} onClick={() => !disabledUpdateTypes.includes("email") && changeInfo("email")}>
                  <img className="img-default" src={imgBtnMail} alt="icon-mail" />
                  <img className="img-hover" src={imgBtnMailHover} alt="icon-mail" />
                </div>
                <div className={actionClass("bank")} onClick={() => !disabledUpdateTypes.includes("bank") && changeInfo("bank")}>
                  <img className="img-default" src={imgBtnBank} alt="icon-bank" />
                  <img className="img-hover" src={imgBtnBankHover} alt="icon-bank" />
                </div>
              </div>
              <div className="action">
                <div className={actionClass("usdt")} onClick={() => !disabledUpdateTypes.includes("usdt") && changeInfo("usdt")}>
                  <img className="img-default" src={imgBtnUsdt} alt="icon-usdt" />
                </div>
                <div className={actionClass("birthday")} onClick={() => !disabledUpdateTypes.includes("birthday") && changeInfo("birthday")}>
                  <img className="img-default" src={imgBtnBirthday} alt="icon-birthday" />
                </div>
              </div>
              <span className="profile-titlte title-btn-change">LẤY LẠI MẬT KHẨU</span>
              <div className="action">
                <div className={actionClass("forget_password")} onClick={() => !disabledUpdateTypes.includes("forget_password") && changeInfo("forget_password")}>
                  <img className="img-default" src={imgBtnPassLogin} alt="icon-forget-password" />
                </div>
                <div className={actionClass("forget_password_withdraw")} onClick={() => !disabledUpdateTypes.includes("forget_password_withdraw") && changeInfo("forget_password_withdraw")}>
                  <img className="img-default" src={imgBtnPassWithdraw} alt="icon-forget-password-withdraw" />
                </div>
              </div>
              <div className="action" style={{ justifyContent: "center" }}>
                <div className="action action-verify">
                  <button className={actionClass("other_note", "action-verify-btn action-verify-btn-img")} disabled={disabledUpdateTypes.includes("other_note")} onClick={() => changeInfo("other_note")}>
                    <img src={iconLinkskh} alt="icon-bank" />
                    &nbsp; CHĂM SÓC KHÁCH HÀNG XÁC MINH
                  </button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        <Popup
          open={openRequestHistoryResult}
          onClose={() => setOpenRequestHistoryResult(false)}
          position="center"
          closeOnDocumentClick
          overlayStyle={{ display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0, 0, 0, 0.35)" }}
          contentStyle={{ position: "relative", inset: "auto", width: "auto", padding: 0, border: "none", background: "transparent" }}
        >
          <div className="request-history-modal">
            <button className="request-history-modal-close" onClick={() => setOpenRequestHistoryResult(false)} aria-label="Đóng popup lịch sử yêu cầu">
              <img src={iconClose} alt="Đóng" />
            </button>
            {requestHistory ? (
              <div className={`request-history-result status-${requestHistory.status}`}>
                <h3>KẾT QUẢ YÊU CẦU</h3>
                <p><strong>Loại yêu cầu:</strong> {requestTypeText[requestHistory.update_type] || requestHistory.update_type}</p>
                {requestHistory.data_update?.content && <p><strong>Nội dung yêu cầu:</strong> {requestHistory.data_update.content}</p>}
                <p><strong>Trạng thái:</strong> {requestStatusText[requestHistory.status] || requestHistory.status}</p>
                {requestHistory.status === "no_process" && ["email", "phone_number"].includes(requestHistory.send_type) && (
                  <p className={`verification-status verification-${requestHistory.verification_status || "not_received"}`}>
                    {getVerificationStatusText(requestHistory.verification_status || "not_received", requestHistory.send_type)}
                  </p>
                )}
                {(requestHistory.note || requestHistory.result) && (
                  <div className="request-result-note">
                    <strong>Ghi chú/Kết quả:</strong>
                    <HtmlNote html={requestHistory.note || requestHistory.result} />
                  </div>
                )}
                {requestHistory.createdAt && <p><strong>Ngày gửi:</strong> {new Date(requestHistory.createdAt).toLocaleString("vi-VN")}</p>}
              </div>
            ) : (
              <div className="request-history-empty">Không tìm thấy thông tin yêu cầu.</div>
            )}
          </div>
        </Popup>
      </div>
    );
  }
}

export default Profile;
